<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter10">
<h1><a id="page_28"></a><a href="#/003toc#ch10">Ginger Pear Pumpkin Soup</a></h1>
<p class="noindent">Pumpkin isn’t just for Halloween and shouldn’t be reserved for pies. This delicious soup spiked with ground ginger will be a welcome warm-up on a cool evening when served with some crusty bread. The soup can be frozen for up to two months.</p>
<p class="noindent">4 tablespoons (½ stick) unsalted butter</p>
<p class="noindent">½ cup finely chopped sweet onion</p>
<p class="noindent">½ cup finely chopped celery</p>
<p class="noindent">½ cup finely chopped carrot</p>
<p class="noindent">2 medium red pears, peeled, cored, and finely chopped</p>
<p class="noindent">½ teaspoon ground ginger</p>
<p class="noindent">Two 15-ounce cans pumpkin purée (see savvy)</p>
<p class="noindent">3 cups chicken broth</p>
<p class="noindent">Salt and freshly ground black pepper</p>
<p class="noindent">1 cup heavy cream</p>
<p class="noindent">melt the butter in a medium skillet over medium-high heat. Add the onion, celery, carrot, pears, and ginger and sauté until the vegetables begin to soften, about 3 minutes. Transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker.</p>
<p class="noindent">stir in the pumpkin and broth. Cover and cook on high for 3 hours or on low for 5 to 6 hours.</p>
<p class="noindent">season with salt and pepper. Stir in the cream, cover, and leave on warm for 30 minutes before serving.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/>pumpkin savvy</p>
<p class="noindent">Pumpkin purée sold in cans is terrific for any preparation that calls for pumpkin. Cooking your own pumpkin can be a messy and frustrating process that sometimes ends with a watery mess. Make sure to buy pumpkin purée and not pumpkin pie filling.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 016-chapter10.vue?53f25429